/* global axios */
import ApiClient from './ApiClient';

/**
 * OCHAT: cliente de la API de Reservas.
 *
 * Los endpoints que no son CRUD van con métodos propios porque la API está pensada
 * para el agente IA y tiene verbos que no encajan en el molde REST: `availability`
 * y `quote` preguntan por inventario y no operan sobre una reserva, y `holds`
 * aparta sin vender.
 */
class BookingsAPI extends ApiClient {
  constructor() {
    super('bookings', { accountScoped: true });
  }

  /**
   * La lista, con filtros del lado del servidor.
   *
   * Se sobreescribe `get` porque el de ApiClient descarta sus argumentos
   * (`axios.get(this.url)` a secas), asi que el filtro de estado de la pantalla
   * de reservas nunca llegaba a la API y la lista volvia siempre completa. Es la
   * misma convencion que usa api/contacts.js.
   *
   * Acepta: status, contact_id, from, to, limit.
   */
  get(params = {}) {
    return axios.get(this.url, { params });
  }

  /** Ofertas y rechazos con motivo para un rango. */
  availability({ checkin, checkout, adults = 2, children = 0, propertyId }) {
    return axios.get(`${this.url}/availability`, {
      params: {
        checkin,
        checkout,
        adults,
        children,
        property_id: propertyId,
      },
    });
  }

  /** Total y desglose por noche, sin apartar nada. */
  quote(payload) {
    return axios.post(`${this.url}/quote`, payload);
  }

  /** Aparta el inventario por unos minutos. */
  hold(payload) {
    return axios.post(`${this.url}/holds`, payload);
  }

  /** Reprograma o cambia la ocupación. */
  reschedule(id, payload) {
    return axios.patch(`${this.url}/${id}`, payload);
  }

  /**
   * Cancelar y marcar no-show son el mismo endpoint. Se separan acá porque del lado
   * de la interfaz son dos acciones distintas con consecuencias distintas.
   */
  cancel(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  markNoShow(id) {
    return axios.delete(`${this.url}/${id}`, { params: { no_show: true } });
  }
}

export default new BookingsAPI();
